const jQuery = $.noConflict()
if (!window) { jQuery() } // This is just to avoid the standard lint warning

document.documentElement.setAttribute('data-useragent', navigator.userAgent)
